
function isPC() {
    const sUserAgent = navigator.userAgent.toLowerCase();
    const bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    const bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    const bIsMidp = sUserAgent.match(/midp/i) == "midp";
    const bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    const bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    const bIsAndroid = sUserAgent.match(/android/i) == "android";
    const bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    const bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        return false
    } else {
        return true
    }
}

function isIOS() {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

function isAndroid() {
    return navigator.userAgent.indexOf('Android') > -1
}


function isIE() {
    if(!!window.ActiveXObject || "ActiveXObject" in window){
      return true;
    }else{
      return false;
　　 }
}

// 1.微信移动端 2.微信PC 3.非微信
function isWechat() {
    const ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        if (isPC()) return 2
        return 1
    } else {
        return 3
    }
}

function getWechatVersion() {
    const wechat_info = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i)
    if (!wechat_info) {
        return 0
    } else {
        return wechat_info[1]
    }
}

function isChinese() {
    const language = navigator.language || navigator.userLanguage
    return /zh-/.test(language.toLowerCase())
}

  
export default {
    isPC,
    isIOS,
    isAndroid,
    isWechat,
    getWechatVersion,
    isChinese,
    isIE
}